import { render, staticRenderFns } from "./MoreInfoBlock.vue?vue&type=template&id=63981d13&scoped=true"
import script from "./MoreInfoBlock.vue?vue&type=script&lang=js"
export * from "./MoreInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63981d13",
  null
  
)

export default component.exports